import { MetaPixelProvider } from "@adkit.so/meta-pixel-react";
import React from "react";

export const META_PIXEL_ID = "480271133738341";

type MetaPixelRootProps = {
  children: React.ReactNode;
};

export function MetaPixelRoot({ children }: MetaPixelRootProps) {
  return (
    <MetaPixelProvider pixelIds={META_PIXEL_ID}>{children}</MetaPixelProvider>
  );
}
